module.exports = __webpack_public_path__ + "static/dotnetcore-da33983229bb45d7b2196257bb8754db.png";